exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.action[data-v-dace488e]{margin-right:5px!important}img.qrCode[data-v-dace488e]{max-width:240px;margin:0 30px}", ""]);

// exports
